<template>
  <el-dialog
    :title="title"
    :visible="true"
    width="500px"
    @close="$router.replace('/lists')"
    :close-on-click-modal="false"
  >
    <el-form
      :model="county"
      :rules="rules"
      ref="countyForm"
      label-position="top"
      v-loading="loading"
      autocomplete="off"
      @submit.native.prevent="add"
    >
      <el-form-item
        prop="name"
        label="Név"
        :error="errors.name ? errors.name[0] : null"
      >
        <el-input v-model="county.name"/>
      </el-form-item>
    </el-form>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="$router.replace('/lists')">
        Mégse
      </el-button>
      <el-button
        type="primary"
        @click="add"
        :loading="buttonLoading"
      >
        {{ buttonText }}
      </el-button>
    </div>
  </el-dialog>
</template>
<script>
  export default {
    props: ['type', 'countyId'],
    data() {
      return {
        loading: false,
        errors: {
          name: null,
        },
        buttonLoading: false,
        county: {},
        rules: {
          name :[
            { required: true, message: 'Név megadása kötelező', trigger: 'change' }
          ]
        }
      }
    },
    computed: {
      title() {
        if (this.type === 'add') {
          return 'Új Megye';
        } else if (this.type === 'update') {
          return 'Megye módosítása';
        } else {
          return '';
        }
      },
      buttonText() {
        if (this.type === 'add') {
          return 'Hozzáadás';
        } else if (this.type === 'update') {
          return 'Módosítás';
        } else {
          return '';
        }
      },
    },

    methods: {
      async add() {
        this.$refs['countyForm'].validate(async valid => {
          if(valid) {
            this.buttonLoading = true;
            this.errors.name = null;
            try {
              if (this.type === 'add') {
                await this.$store.dispatch('county/add', this.county);
              } else if (this.type === 'update') {
                await this.$store.dispatch('county/update', this.county);
              }
              this.$store.dispatch('county/fetchAll');
              this.buttonLoading = false;
              this.$router.replace('/lists');
            } catch (e) {
              this.buttonLoading = false;
              if (e.data && e.data.errors) {
                this.errors = e.data.errors;
              }
            }
            this.buttonLoading = false;
          }
        });
      }
    },

    async mounted() {
      this.loading = true;
      if(this.countyId) {
        this.county = await this.$store.dispatch('county/fetch', this.countyId);
      }
      this.loading = false;
    }
  }
</script>
